/*
 * Honest empty state for areas whose backing service is not connected
 * (PROGRAMME-AD-NO-FABRICATED-DATA-IN-BUILDS-V1): declare NOT-WIRED truthfully,
 * never seed data that fakes functionality.
 */
export function NotWired({ service }: { service: string }) {
  return (
    <div
      role="status"
      data-wired="false"
      style={{
        border: '1px dashed var(--text-faint)',
        borderRadius: 'var(--r-card, 16px)',
        padding: 20,
        marginTop: 8,
        color: 'var(--text-secondary)',
        background: 'var(--surface)',
        fontSize: 13,
      }}
    >
      <span className="mono" style={{ display: 'block', marginBottom: 6, fontSize: 10, letterSpacing: '.08em', color: 'var(--warn)' }}>NOT WIRED</span>
      {service} is not connected yet. Nothing is shown here because no real data
      source is wired — this panel is replaced by the live view when the
      integration lands.
    </div>
  )
}
